import { Outlet } from "react-router-dom"
import { NavLink, useOutletContext } from "react-router-dom"
import DashboardHeader from "../components/DashboardHeader"

function Settings() { 
    const [paylink, Bal, username, fullname, trans] = useOutletContext() 
  return (
      <>
      <DashboardHeader title="Settings" profilename={fullname}/>
      <div className="settings-container">
        <div className="settings-links">
            <NavLink className="settings-link" to="general">
                General
            </NavLink>
            <NavLink className="settings-link" to="bank-settings">
                Bank Account
            </NavLink>
        </div>
        <Outlet />
    </div>
      </>
    
  )
}

export default Settings